var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeusplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 14,
    viewBox: "0 0 80 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_19701)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4902 8.58184L21.5775 7.94291L18.339 7.94482L18.4473 7.25101L21.473 7.23909L21.8419 4.49632L18.819 4.48534L18.924 3.81444L22.1095 3.81349L22.5886 0.743857L15.6191 0.734314L14.4901 8.58184H21.4902Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6079 7.98681L31.6143 0.739563L27.9153 0.744335L26.9447 7.6819C26.9242 7.82839 26.8268 8.14714 26.4613 8.14714C26.0958 8.14714 26.03 7.87372 26.0548 7.69192L27.0191 0.742426L23.2724 0.741472L22.2665 7.98681C22.2379 8.18865 22.2365 8.38763 22.2589 8.58184H30.4514C30.5278 8.38429 30.5812 8.18436 30.6084 7.98681H30.6079Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6132 7.77301L31.3489 8.58229H38.4267C38.5346 8.23062 38.6028 7.8632 38.6143 7.51677C38.662 6.08336 38.5384 5.27742 36.76 4.64183C36.1945 4.43951 35.7155 4.47625 35.4716 4.27298C35.3437 4.16609 35.2855 3.92751 35.4645 3.79199C35.9784 3.40262 37.6699 3.81871 38.3838 3.90842L39.2346 0.992437C35.7636 -0.151814 32.5867 0.639332 31.7688 4.00338C31.4185 5.44347 31.9 6.38779 32.9025 6.91411C33.4584 7.20566 34.7086 7.34595 34.9272 7.65086C35.2111 8.04691 34.2362 8.10321 34.0492 8.09701C33.238 8.07077 32.3862 8.02305 31.6128 7.77349L31.6132 7.77301Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5325 0.743385L14.8504 0.721436L14.3307 3.71376L10.6961 8.01879H13.8412L13.7629 8.58185H6.4541L6.54429 8.01879L10.0944 3.71376H7.12071L7.5325 0.743385Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.544312 8.92206H79.4557V9.42165H0.544312V8.92206Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1138 8.5818C46.5849 8.24778 47.4863 7.26433 47.7277 5.53984L47.8694 4.52729C48.2502 1.80695 47.2214 0.748585 44.8852 0.742859L40.3659 0.732361L39.2747 8.5818H45.1138ZM44.3699 4.42231L44.2301 5.3652C44.1585 5.87959 43.4842 5.86527 43.2543 5.86527L43.5654 3.73996C43.9204 3.73996 44.4825 3.66409 44.3699 4.42279V4.42231Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8356 7.69044L74.3896 0.759083L70.6729 0.742859L69.5869 3.77336L69.2304 0.742859H65.5496L67.0999 7.79256L66.9715 8.5818H70.7116L70.8356 7.69044Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5819 7.9868L52.5968 0.736694L48.9579 0.742898L47.87 8.58183H54.5127L54.5962 7.9868H51.5819Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1829 8.5818L63.3307 0.742859H58.3805L55.5304 8.5818H64.1829ZM60.5583 6.47843H59.8097L60.6175 3.79865L60.5583 6.47843Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6946 11.4763L13.4293 13.3902H6.06848L6.34667 11.6529L13.6946 11.4763Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3256 10.9047L30.6981 12.8248C30.9286 12.9728 31.9536 13.1999 32.3133 13.2567C33.9033 13.5077 36.2996 13.4943 37.5727 12.34C37.9415 12.0055 38.2708 11.3905 38.4569 10.7334L31.3261 10.9047H31.3256Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3099 11.2693C22.6153 12.5123 23.9357 13.4867 25.6926 13.4953L26.5653 13.4995C28.3795 13.5086 29.8735 12.3477 30.4132 11.0741L22.3099 11.2688V11.2693Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1437 13.3902H21.1624L21.4487 11.2902L14.4214 11.4591L14.1437 13.3902Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3218 13.3769L63.9749 10.1832L55.6192 10.3841L54.5265 13.3897L58.309 13.385L58.8329 11.6963H60.3728L60.336 13.3821L64.3218 13.3769Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8017 10.5721L47.4133 13.374L54.0551 13.3535L54.4673 10.4117L47.8017 10.5721Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7126 10.0749L70.7407 10.0205L66.963 10.1112L66.9773 10.177L66.4581 13.3741C66.4724 13.3807 69.8083 13.3683 70.2545 13.3741L70.7126 10.0749Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6995 11.097C44.5899 11.0994 45.3415 10.9428 45.9432 10.6165L39.1779 10.7792L38.8171 13.374L42.4198 13.3902L42.7361 11.0946L43.6995 11.0974V11.097Z",
    fill: "rgba(var(--provider-icon-color))"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_19701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.9114,
    height: 13,
    fill: "white",
    transform: "translate(0.544312 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeusplay);
export default __webpack_public_path__ + "static/media/zeusplay.02d20de98110e4abbb467c838c86826d.svg";
export { ForwardRef as ReactComponent };